import React from "react";
import {useSelector} from "react-redux";
import {Features, FeaturesContext} from "@timgroup/common-javascript-components";
import Immutable from "immutable";

const ProvideFeaturesFromRedux = ({ children }) => {
    const activeFeatures = useSelector(state => state.activeInDevFeatures);
    return (
        <FeaturesContext.Provider value={new Features(activeFeatures.valueSeq().reduce((acc, val) => acc.union(val), Immutable.Set()).toJS())}>
            {children}
        </FeaturesContext.Provider>
    )
};

export default ProvideFeaturesFromRedux;
